<template>
  <q-input
    @keyup.enter="triggerSearch"
    clear-icon="close"
    clearable
    dark
    data-id="searchInput"
    debounce="500"
    dense
    label="Search Iris"
    rounded
    standout
    style="width: 30em"
    type="search"
    v-model="filter"
  >
    <template #prepend>
      <q-icon name="search" />
    </template>
  </q-input>
</template>
<script lang="ts">
import { DEFAULT_SEARCH_SIZE } from '@/config'
import { defineComponent, ref } from 'vue'
import { useRouter } from 'vue-router/composables'

export default defineComponent({
  setup() {
    const filter = ref('')
    const router = useRouter()

    function triggerSearch() {
      const route = router.resolve({ name: 'search' })
      const defaultParams = `?size=${DEFAULT_SEARCH_SIZE}&q=${filter.value}`
      router.push(route.href + defaultParams)
    }

    return { filter, triggerSearch }
  },
})
</script>
